export const HOSTERA_PMS = 'HOSTERA'
export const NO_PMS_INTEGRATION = 'NO_INTEGRATION'
